import React from 'react';
import { Link } from '@sunrun/component-library';
import { useTranslation } from 'react-i18next';
import { BILLING_ROUTE, DASHBOARD_ROUTE } from '../constants/routes';
import FullScreenError from '../components/error/FullScreenError';
import { useCurrentOwner } from '../hooks/useUser';

const UnknownPage = () => {
  const { t } = useTranslation();
  const isCurrentOwner = useCurrentOwner();

  return (
    <FullScreenError
      showTopNavbar
      message={
        <>
          <p>{t("Oops, we can't find this page!")}</p>
          {isCurrentOwner ? (
            <Link to={DASHBOARD_ROUTE}>{t('Go back to your Energy System')}</Link>
          ) : (
            <Link to={BILLING_ROUTE}>{t('Go back to your Billing')}</Link>
          )}
        </>
      }
    />
  );
};

export default UnknownPage;
